import { CircleCheck } from "lucide-react";
import React from "react";
import { v4 } from "uuid";

import {
  IgButton,
  IgCopyTextTypography,
  IgDivider,
  IgPaper,
  IgTypography,
} from "@intelligems/ig-theme";
import { BaseIntegrationDto } from "@intelligems/ig-types";
import { Grid, Skeleton, useTheme } from "@mui/material";

import { useGetIntegrations } from "../../../../api/integrations/get-integrations";
import { usePutApiIntegration } from "../../../../api/integrations/put-api-integration";

interface AmpedIntegrationProps {
  ampedIntegration?: BaseIntegrationDto;
}

export const AmpedIntegration = ({
  ampedIntegration,
}: AmpedIntegrationProps) => {
  const integrations = useGetIntegrations();
  const putApiIntegration = usePutApiIntegration();
  const theme = useTheme();
  const onEnableClick = (action: "new" | "refresh" | "delete") => {
    putApiIntegration.mutate({
      body: {
        app: "Amped",
        keys: [
          {
            id: ampedIntegration?.id ? ampedIntegration.id : v4(),
            action,
            description: "Amped Integration",
            name: "Amped",
          },
        ],
      },
      pathParams: undefined,
      queryParams: undefined,
    });
  };

  return (
    <IgPaper sx={{ boxShadow: "none" }}>
      <Grid
        container
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Grid item>
          <Grid container alignItems={"center"} columnSpacing={2}>
            {ampedIntegration?.enabled ? (
              <Grid item>
                <CircleCheck size={24} color={theme.igIconColors.success} />
              </Grid>
            ) : null}
            <Grid item>
              <IgTypography
                variant={"h3"}
                sx={{
                  fontWeight: 600,
                }}
              >
                Amped
              </IgTypography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <IgButton
            variant={"contained"}
            loading={putApiIntegration.isPending}
            onClick={() => onEnableClick(ampedIntegration ? "refresh" : "new")}
          >
            {ampedIntegration ? "Regenerate Token" : "Enable"}
          </IgButton>
        </Grid>
      </Grid>
      {ampedIntegration && ampedIntegration?.enabled ? (
        <Grid container item direction={"column"}>
          <Grid item>
            <IgDivider spacing={"s"} />
          </Grid>

          <Grid container item alignItems={"center"} columnSpacing={2}>
            <Grid item>
              <IgTypography sx={{ fontWeight: 600 }}>
                Access Token:{"  "}
              </IgTypography>
            </Grid>
            <Grid item sx={{ width: "388px" }}>
              {putApiIntegration.isPending || integrations.isFetching ? (
                <Skeleton />
              ) : (
                <IgCopyTextTypography
                  text={ampedIntegration.apis[0].accessToken}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      ) : null}
    </IgPaper>
  );
};
